export default __webpack_public_path__ + "static/media/Resume.e2c85304.pdf";